export const defaultColors = {
  primary: '#3DA865',
  secondary: '#0366DE',
};
